<template>
  <section class="py-5">
    <div class="container">
      <div class="card border-0 shadow-sm">
        <div class="card-body p-4 p-md-5">
          <h1 class="mb-3">Privacy Policy</h1>
          <p class="text-muted">Last updated: March 28, 2026</p>

          <p>
            FinPlan respects your privacy. This Privacy Policy explains what information
            we collect, how we use it, and how we protect it when you use the FinPlan application.
          </p>

          <h2 class="h4 mt-4">1. Information We Collect</h2>
          <p>We may collect the following information:</p>
          <ul>
            <li>Your account information, such as email address and profile name.</li>
            <li>Authentication data received from sign-in providers such as Google.</li>
            <li>Financial data that you choose to enter into the application, including accounts, categories, transactions, and plans.</li>
            <li>Technical information required for operation, security, and debugging.</li>
          </ul>

          <h2 class="h4 mt-4">2. How We Use Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide access to the application.</li>
            <li>Authenticate users and keep accounts secure.</li>
            <li>Store and display your financial records within the app.</li>
            <li>Improve functionality, reliability, and security.</li>
          </ul>

          <h2 class="h4 mt-4">3. Google Sign-In</h2>
          <p>
            If you sign in with Google, FinPlan may receive your basic profile information,
            such as your email address, name, and profile image, in accordance with the permissions
            you grant during authentication.
          </p>

          <h2 class="h4 mt-4">4. Data Sharing</h2>
          <p>
            We do not sell your personal data. We do not share your personal information with third parties
            except when required to operate the service, comply with the law, or protect the security of the application.
          </p>

          <h2 class="h4 mt-4">5. Data Storage and Security</h2>
          <p>
            We take reasonable technical and organizational measures to protect your information.
            However, no method of storage or transmission over the Internet can be guaranteed to be fully secure.
          </p>

          <h2 class="h4 mt-4">6. Data Retention</h2>
          <p>
            We retain your data for as long as your account remains active or as needed
            to provide the service and comply with legal obligations.
          </p>

          <h2 class="h4 mt-4">7. Your Rights</h2>
          <p>
            Depending on your jurisdiction, you may have rights related to access, correction,
            or deletion of your personal data.
          </p>

          <h2 class="h4 mt-4">8. Contact</h2>
          <p class="mb-0">
            For privacy-related questions, contact:
            <a href="mailto:thebestrubl@gmail.com">thebestrubl@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>